import {
  easiestText,
  hardestText,
  longestText,
  newestText,
  relevanceText,
  shortestText,
  topRatedText,
  trendingText,
} from '../i18n/translations';

export const getSortByToLabel = (includeRelevance: boolean) => ({
  newest: newestText(),
  topRated: topRatedText(),
  trending: trendingText(),
  easiest: easiestText(),
  hardest: hardestText(),
  shortest: shortestText(),
  longest: longestText(),
  ...(includeRelevance && {
    relevance: relevanceText(),
  }),
});

export const getSortOptions = (includeRelevance: boolean) =>
  Object.values(getSortByToLabel(includeRelevance));

export const getSortBy = (sortLabel: string): string => {
  const sortObj = getSortByToLabel(true);
  return Object.keys(sortObj).find(sortKey => sortObj[sortKey] === sortLabel);
};
